import Root from "../layouts/Root";
import DesignTable from "../components/designs/DesignTable";
import {faCube} from "@fortawesome/free-solid-svg-icons";
import IconText from "../components/IconText";
import iconMakes from "../assets/img/icon-makes.png";

export default function Designs() {

    const rightContent = (
        <div>
            <h1><IconText text={"3D Models"} icon={faCube}></IconText> </h1>

            <DesignTable/>
        </div>
    )
    return (
        <div className="design-page">
            <Root rightContent={rightContent} icon={iconMakes}/>
        </div>
    )
}
